import { HeadingTag, SemanticTextTag } from '@/common/pd-meta-components-types'
import { CSSProperties, FC, ReactNode } from 'react'

type DefaultTextTag = HeadingTag | 'div' | 'p' | 'span'

interface SemanticTextProps {
  as?: SemanticTextTag | null
  defaultTag: DefaultTextTag
  className?: string
  style?: CSSProperties
  children: ReactNode
}

const SemanticText: FC<SemanticTextProps> = ({ as, defaultTag, className, style, children }) => {
  const Tag = as ?? defaultTag

  return (
    <Tag className={className} style={style}>
      {children}
    </Tag>
  )
}

export default SemanticText
